import { BaseComponent } from 'project/general';

class ToggleMenuComponent extends BaseComponent {

    constructor(...args) {
        super(...args);

        this.onClick = this.onClick.bind(this);
    }

    static getNamespace() {
        return 'toggle-menu';
    }

    onInit() {
        this.element.addEventListener('click', this.onClick);
        this.element.addEventListener('keyup', this.keyDown);
    }

    onClick = () => {
        this.element.classList.toggle('active');
    };

    keyDown = () => {
        if (event.keyCode === 13 || event.keyCode === 32) {
            if (this.element.classList.contains('active')) {
                this.element.classList.remove('active');
            } else {
                this.element.classList.add('active');
            }
        }
    };
}

export default ToggleMenuComponent;
